'use strict';

frontendApp.controller('AddTagModalCtrl', ['$scope', '$uibModalInstance', '$rootScope', 'project', 'tag', 'TagService', 'NotificationService',
  function ($scope, $uibModalInstance, $rootScope, project, tag, TagService, NotificationService) {
    $scope.project = project;
    $scope.tag = tag;

    $scope.saving = false;
    if (tag) {
      $scope.action = "Edit";
      if (tag.exclusions && tag.exclusions.length > 0) {
        TagService.FindMany($scope.project.id, _.map(tag.exclusions, function (t) {
          return t.id;
        }), function (data) {
          tag.exclusionObjects = data;
        });
      } else {
        tag.exclusionObjects = [];
      }
      if (tag.inverses && tag.inverses.length > 0) {
        TagService.FindMany($scope.project.id, _.map(tag.inverses, function (t) {
          return t.id;
        }), function (data) {
          tag.inverseObjects = data;
        });
      } else {
        tag.inverseObjects = [];
      }
      if (tag.children && tag.children.length > 0) {
        TagService.FindMany($scope.project.id, _.map(tag.children, function (t) {
          return t.id;
        }), function (data) {
          tag.childrenObjects = data;
        });
      } else {
        tag.childrenObjects = [];
      }

    } else {
      $scope.tag = TagService.CreateTag($scope.project.id);
      $scope.tag.isNameEditable = true;
      $scope.action = "Add";
    }


    $scope.close = function (result) {
      if ($scope.saving) return;
      $uibModalInstance.close(result);
    };

    $scope.saveTag = function (tag) {

      $scope.saving = true;
      $scope.updateRelationships(tag);

      if (tag.id) {
        $scope.update(tag)
      } else {
        $scope.add(tag);
      }


    };

    $scope.update = function (tagToSave) {

      var tagResourceService = TagService.AsResource(tagToSave);
      tagResourceService.$update(function (tag) {

        $scope.saving = false;
        $scope.close(tag);
        $scope.tag = tag;

        NotificationService.addSuccess({
          title: 'Tag updated succesfully',
          description: 'Name: ' + tag.name,
          timeout: 5000
        });
        $scope.updateFromOldTag(tagToSave, tag);
        $rootScope.$emit("TagSaved", tag);

      }, function (data) {
        $scope.saving = false;
      });
    }

    $scope.add = function (tagToSave) {
      var tagResourceService = TagService.AsResource(tagToSave);
      tagResourceService.$save(function (tag) {

        $scope.saving = false;
        $scope.close(tag);
        $scope.tag = tag;

        NotificationService.addSuccess({
          title: 'Tag added succesfully',
          description: 'Name: ' + tag.name,
          timeout: 5000
        });

        $scope.updateFromOldTag(tagToSave, tag);
        $rootScope.$emit("TagSaved", tag);

      }, function (data) {
        $scope.saving = false;
      });
    }

    $scope.updateRelationships = function (tag) {
      tag.exclusions = [];
      tag.inverses = [];
      tag.children = [];

      angular.forEach(tag.exclusionObjects, function (relation) {
        tag.exclusions.push(relation.id);
      });
      angular.forEach(tag.inverseObjects, function (relation) {
        tag.inverses.push(relation.id);
      });
      angular.forEach(tag.childrenObjects, function (relation) {
        tag.children.push(relation.id);
      });
    }

    $scope.updateFromOldTag = function (tagToSave, savedTag) {
      savedTag.exclusionObjects = tagToSave.exclusionObjects;
      savedTag.inverseObjects = tagToSave.inverseObjects;
      savedTag.childrenObjects = tagToSave.childrenObjects;
    }

  }]);
